import { fak } from '@awesome.me/kit-da59d5031a/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Stack, Typography } from '@mui/material';

import { EhrProvider } from 'src/store/sageAdminApi';
import { getEhrProviderDisplayName } from 'src/utils/ehrUtils';

interface SyncedWithEhrLabelProps {
    ehrProvider?: EhrProvider;
}

const SyncedWithEhrLabel = ({ ehrProvider }: SyncedWithEhrLabelProps) => {
    return (
        <Stack direction="row" sx={{ alignItems: 'center', gap: 1 }}>
            <FontAwesomeIcon icon={fak.faMedtech} />
            <Typography variant="body2">
                Synced with {getEhrProviderDisplayName(ehrProvider || '')}
            </Typography>
        </Stack>
    );
};

export default SyncedWithEhrLabel;
